<template>
  <section class="vacancy-inner">
    <BreadCrumb />
    <div class="container vacancy-content">
      <div class="left-content">
        <h2 class="font-34 uppercase pangram-black">
          {{ _.get(contentData, "data.list[0].title") }}
        </h2>
        <div
          class="text"
          v-html="_.get(contentData, 'data.list[0].content')"
        ></div>
      </div>
      <div class="right-content">
        <div class="go-back" @click="goBack()">
          <IconComopnent name="back" />
          <p>{{ $fn.tr("უკან") }}</p>
        </div>
        <div class="contact-card">
          <div class="single-info">
            <p class="font-16 bold">
              {{ _.get(contactInfo, "email[0].tipText") }}
            </p>
            <a
              href="tel:_.get(contactInfo, 'email[0].tipHover)"
              class="font-16 pangram-medium"
            >
              {{ _.get(contactInfo, "email[0].tipHover") }}</a
            >
          </div>
          <div class="single-info">
            <p class="font-16 bold">
              {{ _.get(contactInfo, "mobile[0].tipText") }}
            </p>
            <a
              href="tel:_.get(contactInfo, 'mobile[0]tipHover)"
              class="font-16 pangram-medium"
            >
              {{ _.get(contactInfo, "mobile[0]tipHover") }}</a
            >
          </div>
          <div class="single-info">
            <p class="font-16 bold">
              {{ _.get(contactInfo, "addres[0].tipText") }}
            </p>
            <p class="font-16 pangram-medium">
              {{ _.get(contactInfo, "addres[0]tipHover") }}
            </p>
          </div>
          <div class="single-info">
            <p class="font-16 bold">
              {{ $fn.tr("სოც. ქსელი:") }}
            </p>
            <div class="social-links">
              <a
                :target="
                  _.get(contactInfo, 'facebook.targetblank') ? '_blank' : ''
                "
                :href="_.get(contactInfo, 'facebook.url')"
                v-html="_.get(contactInfo, 'facebook.svg')"
              >
              </a>
              <a
                :target="
                  _.get(contactInfo, 'instagram.targetblank') ? '_blank' : ''
                "
                :href="_.get(contactInfo, 'instagram.url')"
                v-html="_.get(contactInfo, 'instagram.svg')"
              >
              </a>
              <a
                :target="
                  _.get(contactInfo, 'facebook.targetblank') ? '_blank' : ''
                "
                :href="_.get(contactInfo, 'facebook.url')"
                v-html="_.get(contactInfo, 'facebook.svg')"
              >
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import IconComopnent from "../SvgComponents.vue";
import BreadCrumb from "@/components/modules/BreadCrumb";
export default {
  props: ["contentData"],
  components: {
    IconComopnent,
    BreadCrumb
  },
  data() {
    return {};
  },
  computed: {
    contactInfo() {
      let widgetData = _.get(
        this.$store.state.main,
        "indx.widgets.vacancy_contact"
      );
      return widgetData;
    }
  },
  methods: {
    goBack() {
      if (this.$route.fullPath?.includes("singleview")) {
        if (this.$route.params.path2 == "singleview") {
          this.$router.push(
            `/${_.get(this.$store.state.main, "indx.locale")}/${
              this.$route.params.path1
            }`
          );
        } else {
          this.$router.push(
            `/${_.get(this.$store.state.main, "indx.locale")}/${
              this.$route.params.path1
            }/${this.$route.params.path2}`
          );
        }
      }
    }
  }
};
</script>

<style lang="scss">
.vacancy-inner {
  // padding-top: 55px;
  padding-bottom: 144px;
  @media (max-width: 1439px) {
    padding-bottom: 89px;
  }
  @media (max-width: 1023px) {
    padding-bottom: 34px;
    padding-bottom: 55px;
  }
  background: $dirtywhite;
  .vacancy-content {
    display: flex;
    justify-content: space-between;
    padding-top: 0;
    @media (max-width: 1023px) {
      flex-direction: column;
    }
    .left-content {
      padding-right: 30px;
      max-width: 960px;
      width: 100%;

      h2 {
        margin-bottom: 34px;
      }
      .text {
        color: $lightGray2;
        @media (max-width: 1023px) {
          margin-bottom: 55px;
        }
      }
      width: 100%;
    }
    .right-content {
      width: 350px;
      @media (max-width: 1023px) {
        width: 100%;
      }
      .go-back {
        display: flex;
        cursor: pointer;
        align-items: center;
        justify-content: flex-end;
        margin-bottom: 34px;
        @media (max-width: 1023px) {
          display: none;
        }
        svg {
          path {
            fill: $black;
          }
        }
        p {
          margin-left: 5px;
          color: $black;
        }
      }
      .contact-card {
        padding: 34px 30px;
        background: $white;
        @media (max-width: 1023px) {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
        }
        .single-info {
          @media (max-width: 1023px) {
            width: 30%;
            min-width: 250px;
          }
          p {
            color: $lightGray2;
            &.bold {
              margin-bottom: 5px;
            }
          }
          a {
            color: $lightGray2;
            &.bold {
              margin-bottom: 5px;
            }
          }
          &:not(:last-child) {
            margin-bottom: 25px;
            padding-bottom: 21px;
            border-bottom: 1px solid rgba(77, 77, 79, 0.1);
            @media (max-width: 1023px) {
              border-bottom: none;
            }
          }
          .social-links {
            display: flex;
            flex-wrap: wrap;
            a {
              margin-top: 5px;
              &:not(:last-child) {
                margin-right: 10px;
              }
              svg {
                path {
                  fill: $black;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
